import React, { Component } from 'react'
import cn from 'classnames'
import { BtnV2, LinkBtn, l, sanitizeURL } from '@manychat/manyui'

import { PreviewButton } from 'apps/flowPlayer/components/PreviewButton/PreviewButton'
import Toolbar from 'common/builder/components/chart/FlowChart/Toolbar'

import cm from './ControlsPanel.module.css'

const toolbarTheme = {
  toolbar: cm.toolbarWrapper,
  btn: cm.toolbarBtn,
}
export default class ControlsPanel extends Component {
  state = {
    inFullscreen: false,
  }

  componentDidMount() {
    this.listenFullscreen()
  }

  componentWillUnmount() {
    this.unlistenFullscreen()
  }

  listenFullscreen() {
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange)
    document.addEventListener('MSFullscreenChange', this.handleFullscreenChange)
  }

  unlistenFullscreen() {
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange)
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange)
    document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange)
  }

  handleFullscreenChange = () => this.setState({ inFullscreen: this.isInFullscreen() })

  toggleFullscreen = () => {
    const elem = window.document.documentElement
    const isInFullscreen = this.isInFullscreen()
    if (!isInFullscreen) {
      const requestFullScreen =
        elem.requestFullscreen ||
        elem.msRequestFullscreen ||
        elem.mozRequestFullScreen ||
        elem.webkitRequestFullscreen
      requestFullScreen.call(elem)
    } else {
      const exitFullScreen =
        document.exitFullscreen ||
        document.webkitExitFullscreen ||
        document.mozCancelFullScreen ||
        document.msExitFullscreen
      exitFullScreen.call(document)
    }
  }
  isInFullscreen = () =>
    document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement
  render() {
    const { name, avatarUrl, pageName, sharingEnabled, previewUrl, cloningUrl } = this.props
    const { inFullscreen } = this.state

    return (
      <div className={cm.layout}>
        <div className={cm.badge}>
          <span className={cm.badgeName}>{name}</span>
          by
          <img className={cm.badgeAvatar} src={sanitizeURL(avatarUrl)} />
          <span className={cm.badgeAuthor}>{pageName}</span>
        </div>
        <div className={cm.buttons}>
          <PreviewButton builderId={this.props.builderId} messengerPreviewUrl={previewUrl} />
          {Boolean(sharingEnabled && cloningUrl) && (
            <LinkBtn
              className={cm.btn}
              variant="primary"
              size="large"
              href={cloningUrl}
              target="_blank"
            >
              {l.translate('Save to Manychat')}
            </LinkBtn>
          )}
        </div>
        <div className={cm.toolbar}>
          <BtnV2
            onlyIcon={inFullscreen ? 'ExitFullscreen' : 'Fullscreen'}
            onClick={this.toggleFullscreen}
            className={cn(cm.toolbarItem, 'm-r-sm')}
            ariaLabel={
              inFullscreen ? l.translate('Open fullscreen') : l.translate('Exit fullscreen')
            }
          />
          <Toolbar readonly theme={toolbarTheme} onFullscreen={this.fullscreen} />
        </div>
      </div>
    )
  }
}
